import initSqlJs, { type Database } from 'sql.js'
import { useRuntimeConfig } from 'nuxt/app'

export class DatabaseService {
  db: Database | null

  constructor() {
    this.db = null
  }

  async load(buffer: ArrayBuffer) {
    const config = useRuntimeConfig()
    const SQL = await initSqlJs({
      locateFile: () => `${config.app.baseURL.replace(/\/$/, '')}/sql-wasm.wasm`
    })
    this.db = new SQL.Database(new Uint8Array(buffer))
  }

  getTables(): string[] {
    if (!this.db) return []
    const res = this.db.exec("SELECT name FROM sqlite_master WHERE type='table';")
    return res.length > 0 ? res[0]!.values.map(row => row[0] as string) : []
  }

  getWorksite(): any[] {
    if (!this.db) return []
    const res = this.db.exec("SELECT * FROM WorkData;")
    return res.length > 0 ? res[0]!.values[0]! : []
  }

  getMachine(): any[] {
    if (!this.db) return []
    const res = this.db.exec("SELECT * FROM MachineData;")
    return res.length > 0 ? res[0]!.values[0]! : []
  }

  getUser(): any[] {
    if (!this.db) return []
    const tables = this.getTables()
    if (tables.includes('UserData')) {
      const res = this.db.exec("SELECT * FROM UserData;")
      return res.length > 0 ? res[0]!.values[0]! : []
    } else if (tables.includes('Users')) {
      const res = this.db.exec("SELECT * FROM Users;")
      return res.length > 0 ? res[0]!.values[0]! : []
    }
    return []
  }
}